const hotKeyMappings = [
  {
    key: 'alt+b',
    mapping: 'BookLibrary',
  },
  {
    key: 'alt+q',
    mapping: 'QuestLibrary',
  },
  {
    key: 'alt+ctrl+g',
    mapping: 'GraphControls',
  },
  {
    key: 'alt+t',
    mapping: 'ThoughtMap',
  },
  {
    key: 'alt+u',
    mapping: 'GutenbergLibrary',
  },
  {
    key: 'alt+l',
    mapping: 'LinkedThoughts',
  },
  {
    key: 'alt+shift+g',
    mapping: 'GraphLibrary',
  },
  {
    key: 'alt+v',
    mapping: 'TreasureMarker',
  },
  {
    key: 'alt+3',
    mapping: 'ThreeDModelViewer',
  },
  {
    key: 'alt+n',
    mapping: 'NotesLibrary',
  },
  {
    key: 'alt+e',
    mapping: 'Editor',
  },
  {
    key: 'alt+d',
    mapping: 'Detail',
  },
  {
    key: 'alt+w',
    mapping: 'WikiDataCard',
  },
  {
    key: 'alt+r',
    mapping: 'RecentActivity',
  },
  {
    key: 'alt+s',
    mapping: 'Snippet',
  },
  {
    key: 'alt+f',
    mapping: 'Twitterfeed',
  },
  {
    key: 'alt+c',
    mapping: 'Compare',
  },
  {
    key: 'alt+o',
    mapping: 'DendoGraph',
  },
  {
    key: 'alt+h',
    mapping: 'Help',
  },
  {
    key: 'alt+shift+r',
    mapping: 'Recentevents',
  },
  {
    key: 'alt+shift+s',
    mapping: 'SkillGraph',
  },
  {
    key: 'alt+m',
    mapping: 'MiniExplore',
  },
  {
    key: 'alt+i',
    mapping: 'Information',
  },
  {
    key: 'alt+shift+t',
    mapping: 'Thoughtverse',
  },
  {
    key: 'alt+shift+a',
    mapping: 'Thoughtversealt',
  },
  {
    key: 'ctrl+shift+f',
    mapping: 'Thoughtversecontrols',
  },
  {
    key: 'ctrl+alt+s',
    mapping: 'ShareCollaborate',
  },
  {
    key: 'ctrl+alt+l',
    mapping: 'LoaderSemantic',
  },
  {
    key: 'alt+shift+v',
    mapping: 'VisitedGraphVR',
  },
  {
    key: 'alt+ctrl+v',
    mapping: 'VisitedGraphAlt',
  },
  {
    key: 'alt+shift+o',
    mapping: 'ThoughtMarkdown',
  },
  {
    key: 'alt+g',
    mapping: 'GraphExplore',
  },
];

export default hotKeyMappings;
